import { Component, OnInit, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { RegistrationModel } from '../../models/registrationmodel';

@Component({
  selector: 'app-register-complete',
  templateUrl: './register-complete.html',
  styleUrls: ['./register-complete.css'],
  imports: [DatePipe], // Add this using the DatePipe Directive in the template
})
export class RegisterComplete implements OnInit {
  registration: RegistrationModel;

  constructor(
    private storage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.registration = this.storage.retrieve('registration');
  }
}
